import React from 'react';
import '../StyleSheets/MainDashboard.css';
import SideBar from './SideBar';
// import SignIn from './SignIn';

import ChartManager from './ChartManager';
import GlobalSnapshot from './GlobalSnapshot';
import PolicyChronicles from './PolicyChronicles';
import FinancialData from './FinancialData';

export default class MainDashboard extends React.Component {
    
    state = {

        isSignedIn: false,
        currentDisplay: 0
    }

    render() {
        const { appSettings, coronaData } = this.props;
        const { /*isSignedIn,*/ currentDisplay } = this.state;

        return (

            //@ YOTAM: uncomment when implemented.
            // !isSignedIn ? 
            // <SignIn onSignedIn={ () => { 
            //     console.log("Signed In Successfully."); 
            //     this.setState( {isSignedIn: true } ); 
            // } } />
            // :
            <div id="mainContainer">

                <div key="a" className="displaysContainer" >
                    { currentDisplay === 0 ? <ChartManager appSettings={ appSettings } coronaData={ coronaData }/> : null }
                    { currentDisplay === 1 ? <GlobalSnapshot appSettings={ appSettings } coronaData={ coronaData }/> : null }
                    { currentDisplay === 2 ? <PolicyChronicles appSettings={ appSettings } coronaData={ coronaData }/> : null }
                    { currentDisplay === 3 ? <FinancialData appSettings={ appSettings } coronaData={ coronaData }/> : null }
                </div>

                <SideBar lastUpdate={coronaData.lastUpdate} onNav={ i => this.setState({currentDisplay: i})}/>
            </div>
        )

    }

}